import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../security/auth.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //const obtenerTokenReCaptcha: boolean = false; //comentar para pase
    const obtenerTokenReCaptcha: boolean = true; //descomentar para pase
    if (obtenerTokenReCaptcha) {
      return from(this.recaptchaV3Service.execute('login'))
        .pipe(switchMap(token => {
          const reCaptchaReq = request.clone({
            params: request.params.set("reCaptchaToken", token)
          });
          if (!reCaptchaReq.url.endsWith("/access/login")) {
            let authToken: string = this.authService.token;
            if (authToken != null) {
              const authReq = reCaptchaReq.clone({
                headers: reCaptchaReq.headers.set('Authorization', 'Bearer ' + authToken)
              });
              return next.handle(authReq);
            } else {
              return next.handle(reCaptchaReq);
            }
          } else {
            return next.handle(reCaptchaReq);
          }
        }));
    } else {
      if (!request.url.endsWith("/access/login")) {
        let token: string = this.authService.token;
        if (token != null) {
          const authReq = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token)
          });
          return next.handle(authReq);
        }
      }
      return next.handle(request);
    }
  }

}
